// extracted by mini-css-extract-plugin
module.exports = {"title":"CheckboxQuestion_title__crVvo","checkboxWrapper":"CheckboxQuestion_checkboxWrapper__64Qyx"};